export default __webpack_public_path__ + "static/media/logo-footer.3b3d2e72.svg";